import { splitArrayArrange } from "../Pages/Orders/orderTypes";

//Reducer Types
interface State {
  installationPlanData?: any;
  installationPlanCount?: any;
  installationPlanDetails?: any;
  plantHiedServiceData?: any;
}

export const installationPlanReducer = (
  state: State = {
    installationPlanData: [],
    installationPlanCount: [],
    installationPlanDetails: null,
    plantHiedServiceData: [],
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_INSTALLATION_DATA":
      return {
        ...state,
        installationPlanData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.installationPlanData, ...action.payload?.data],
        installationPlanCount: action.payload.count,

        // detail:action.payload.detail
      };
    case "GET_INSTALLATION_DETAILS":
      return {
        ...state,
        installationPlanDetails: action?.payload,
      };
    case "GET_PLANT_HIRED_SERVICES_DATA":
      return {
        ...state,
        plantHiedServiceData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.plantHiedServiceData, ...action.payload?.data],
      };
    default:
      return state;
  }
};
